import styled from 'styled-components'

import { AppFull } from '../../../../AppStyle';

const DowntimesContent = styled(AppFull)`
  overflow: auto;
`

export {DowntimesContent}
